import { MENU_STATE } from '../actions/actionTypes';
import initialState from './initialState';

export default function menuReducer(state = initialState.menu, action) {
    if (action.type === MENU_STATE) {
        return { ...state, open: action.open };
    }
    return state;
}
